<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 50.667 77">
        <g id="Group_2886" data-name="Group 2886" transform="translate(-1346.334 -1221)">
            <g id="pin" transform="translate(1261.001 1221)">
                <g id="Group_2883" data-name="Group 2883" transform="translate(85.333)">
                    <path id="Path_70175" data-name="Path 70175"
                          d="M110.666,0A25.336,25.336,0,0,0,88.374,37.372l20.907,38.811a1.584,1.584,0,0,0,2.771,0L132.966,37.36A25.338,25.338,0,0,0,110.666,0Z"
                          transform="translate(-85.333)" fill="#e21851"/>
                </g>
            </g>
            <circle id="Ellipse_211" data-name="Ellipse 211" cx="20" cy="20" r="20" transform="translate(1352 1226)"
                    fill="#ff7797" opacity="0.4"/>
            <g id="lab" transform="translate(1358.592 1232.592)">
                <path id="Path_70176" data-name="Path 70176"
                      d="M521.788,110a1.788,1.788,0,1,0,1.788,1.788A1.789,1.789,0,0,0,521.788,110Zm0,0"
                      transform="translate(-496.759 -105.084)" fill="#fff"/>
                <path id="Path_70177" data-name="Path 70177"
                      d="M381.341,32.682A1.341,1.341,0,1,0,380,31.341,1.343,1.343,0,0,0,381.341,32.682Zm0,0"
                      transform="translate(-363.016 -28.659)" fill="#fff"/>
                <path id="Path_70178" data-name="Path 70178"
                      d="M501.341,2.682A1.341,1.341,0,1,0,500,1.341,1.343,1.343,0,0,0,501.341,2.682Zm0,0"
                      transform="translate(-477.653)" fill="#fff"/>
                <path id="Path_70179" data-name="Path 70179"
                      d="M70.894,450.447a.447.447,0,1,1-.447-.447A.447.447,0,0,1,70.894,450.447Zm0,0"
                      transform="translate(-66.871 -429.888)" fill="#fff"/>
                <path id="Path_70180" data-name="Path 70180"
                      d="M90.894,540.447a.447.447,0,1,1-.447-.447A.447.447,0,0,1,90.894,540.447Zm0,0"
                      transform="translate(-85.978 -515.865)" fill="#fff"/>
                <path id="Path_70181" data-name="Path 70181"
                      d="M180.894,450.447a.447.447,0,1,1-.447-.447A.447.447,0,0,1,180.894,450.447Zm0,0"
                      transform="translate(-171.955 -429.888)" fill="#fff"/>
                <path id="Path_70182" data-name="Path 70182"
                      d="M112.04,107.543l-7.3-7.3a.817.817,0,0,0-1.395.578.812.812,0,0,0,.239.578l5.44,5.44-.632.632-4.6-4.6-.709.708L105,105.494l-.632.632-1.919-1.919-.709.709,1.025,1.025-.632.632-1.025-1.025-.709.709,1.919,1.919-.632.632-1.919-1.919-.709.709,1.025,1.025-.632.632-1.025-1.025-.709.709,1.919,1.919-.632.632-1.919-1.919-.709.709L97.4,111.3l-.632.632-1.025-1.025-1.6,1.6h11.25l4.655-4.655.84.839a.817.817,0,0,0,1.395-.578.813.813,0,0,0-.239-.578Zm0,0"
                      transform="translate(-89.932 -95.53)" fill="#fff"/>
                <path id="Path_70183" data-name="Path 70183"
                      d="M1.165,402.149a3.978,3.978,0,0,0,5.625,5.625L14.564,400H3.314Zm7.327-.808a1.341,1.341,0,1,1-1.341,1.341A1.343,1.343,0,0,1,8.492,401.341ZM5.81,406.7a1.341,1.341,0,1,1-1.341-1.341A1.343,1.343,0,0,1,5.81,406.7Zm-.894-4.022a1.341,1.341,0,1,1-1.341-1.341A1.343,1.343,0,0,1,4.916,402.682Zm0,0"
                      transform="translate(0 -382.123)" fill="#fff"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ILabPin",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
